import { render, staticRenderFns } from "./KalkinBasicSIT.vue?vue&type=template&id=2642b8fa&scoped=true&"
var script = {}
import style0 from "./KalkinBasicSIT.vue?vue&type=style&index=0&id=2642b8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642b8fa",
  null
  
)

export default component.exports